<div class="profile-page">

  <!-- Avatar -->
  <div class="profile-page__avatar">
    <span class="profile-page__initial">{{ initials() }}</span>
    <div class="profile-page__avatar-action">
      <!-- <app-button
        variant="secondary"
        color="amarante"
        size="small"
        [addLabel]="false"
        [addIconLeft]="true"
        [attr.aria-label]="'PROFILE.CHANGE_AVATAR' | translate"
        (clicked)="openAvatarPopup()"
      >
        <img slot="icon-left" src="assets/icon/new_icon/edit.svg" alt="" aria-hidden="true" />
      </app-button> -->
    </div>
  </div>

  <!-- Name -->
  <div class="profile-page__row">
    <img class="profile-page__icon" src="assets/icon/new_icon/profil.svg" alt="" aria-hidden="true" />
    <span class="profile-page__name">{{ fullName() }}</span>
  </div>

  <!-- Email -->
  <div class="profile-page__row">
    <span class="profile-page__email">{{ email() }}</span>
    <app-button
      variant="tertiary"
      color="mint"
      size="xsmall"
      [addLabel]="false"
      [addIconLeft]="true"
      [attr.aria-label]="'PROFILE.COPY_EMAIL' | translate"
      (clicked)="copyEmail()"
      data-attr="profile-btn-copy-email"
    >
      <img slot="icon-left" src="assets/icon/new_icon/copy.svg" alt="" aria-hidden="true" />
    </app-button>
  </div>

  <!-- Reset password -->
  <!-- <app-button
    [label]="'PROFILE.RESET_PASSWORD' | translate"
    variant="primary"
    color="amarante"
    size="small"
    [addIconLeft]="true"
    (clicked)="resetPassword()"
  >
    <img slot="icon-left" src="assets/icon/new_icon/rotate-right.svg" alt="" aria-hidden="true" />
  </app-button> -->

  <!-- Licences -->
  <div class="profile-page__licences">
    <div class="profile-page__licences-header">
      <h2 class="profile-page__licences-title">{{ 'PROFILE.LICENCES' | translate }}</h2>
      <span class="profile-page__licences-separator"></span>
    </div>

    @if (licences().length > 0) {
      <ul class="profile-page__licences-list">
        @for (licence of licences(); track licence) {
          <li class="profile-page__licence-item">{{ licence }}</li>
        }
      </ul>
    }
  </div>

  <!-- Log out -->
  <app-button
    [label]="'PROFILE.LOGOUT' | translate"
    variant="secondary"
    color="mint"
    size="small"
    [addIconLeft]="true"
    (clicked)="logout()"
    data-attr="profile-btn-logout"
  >
    <img slot="icon-left" src="assets/icon/new_icon/logout.svg" alt="" aria-hidden="true" />
  </app-button>

  <app-popup
    [title]="'PROFILE.CHANGE_AVATAR' | translate"
    [isOpen]="isAvatarPopupOpen"
    size="xsmall"
    variant="secondary"
    color="mint"
    (closed)="closeAvatarPopup()"
  >
    <!-- Input fichier caché -->
    <input
      #fileInput
      type="file"
      accept=".jpg,.jpeg,.png,.pdf"
      class="profile-page__avatar-file-input"
      (change)="onFileSelect($event)"
      data-attr="profile-input-avatar-file"
    />

    <div class="profile-page__avatar-popup-body">

      <!-- Dropzone circulaire -->
      <div
        class="profile-page__avatar-dropzone"
        [class.profile-page__avatar-dropzone--drag-over]="isDragOver"
        [class.profile-page__avatar-dropzone--has-file]="!!selectedFile"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave()"
        (drop)="onDrop($event)"
        data-attr="profile-dropzone-avatar"
      >
        @if (selectedFile && selectedFileUrl) {
          <img
            class="profile-page__avatar-preview"
            [src]="selectedFileUrl"
            [alt]="selectedFile.name"
          />
        } @else if (selectedFile) {
          <span class="profile-page__avatar-dropzone-label">{{ selectedFile.name }}</span>
        } @else {
          <svg class="profile-page__avatar-upload-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M4 16v3a1 1 0 001 1h14a1 1 0 001-1v-3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 3v13M12 3L8 7M12 3L16 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="profile-page__avatar-dropzone-label">{{ 'PROFILE.DRAG_DROP' | translate }}</span>
        }
      </div>

      <!-- Séparateur "ou" -->
      <span class="profile-page__avatar-or">{{ 'PROFILE.OR' | translate }}</span>

      <!-- Bouton générique "Ajouter un fichier" -->
      <app-button
        [label]="'PROFILE.ADD_FILE' | translate"
        variant="tertiary"
        color="mint"
        size="small"
        [addIconLeft]="true"
        (clicked)="triggerFileInput()"
        data-attr="profile-btn-add-file"
      >
        <img slot="icon-left" src="assets/icon/new_icon/add_circle_black.svg" alt="" aria-hidden="true" />
      </app-button>

      <!-- Texte d'aide -->
      <p class="profile-page__avatar-hint">
        {{ 'PROFILE.ACCEPTED_FILE_TYPES' | translate }}<br />
        {{ 'PROFILE.MAX_FILE_SIZE' | translate }}
      </p>

    </div>

    <ng-container slot="footer">
      <!-- Bouton générique Cancel -->
      <app-button
        [label]="'GLOBAL.ANNULER' | translate"
        variant="secondary"
        color="mint"
        (clicked)="closeAvatarPopup()"
        data-attr="profile-btn-cancel"
      />
      <!-- Bouton générique Save (désactivé tant qu'aucun fichier) -->
      <app-button
        [label]="'GLOBAL.ENREGISTRER' | translate"
        variant="primary"
        color="mint"
        [state]="selectedFile ? 'default' : 'disabled'"
        [addIconLeft]="true"
        (clicked)="saveAvatar()"
        data-attr="profile-btn-save"
      >
        <img slot="icon-left" src="assets/icon/new_icon/save.svg" alt="" aria-hidden="true" />
      </app-button>
    </ng-container>
  </app-popup>

</div>
